import { ActionIcon } from './ActionIcon';
import { Button } from './Button';
import { Component, Input, output, input } from '@angular/core';
import { IntegrationConnection } from './IntegrationConnection';
import { IntegrationStatus } from './IntegrationStatus';
import { Toggle } from './Toggle';
import { AppIntegration, AppIntegrationFromTo } from "./DashboardIntegrations";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: 'IntegrationListItem',
  imports: [
    ActionIcon,
    Button,
    IntegrationConnection,
    IntegrationStatus,
    Toggle,
    TranslatePipe
  ],
  template: `
    <div
        class="flex flex-col gap-4 items-start py-6 sm:gap-5 sm:flex-row sm:py-4"
    >
      <div class="flex-none self-start">
        <div
            class="bg-white rounded-lg flex items-center divide-x divide-gray-50 shadow-soft-sm"
        >
          <div class="p-3.5">
            @if (firstApp.apiNameNormalized) {
              <img
                  [alt]="firstApp.apiName"
                  class="{{ status() === 'active' ? '' : 'grayscale opacity-60' }}"
                  src="assets/images/apps/{{ firstApp.apiNameNormalized }}.svg"
                  height="30"
                  width="30"
              />
            }
          </div>

          <IntegrationConnection
              [active]="status() === 'active'"
              class="w-5 h-5 -mx-2.5 !border-0 z-10"
              svgClass="w-4 h-1.5"
          ></IntegrationConnection>

          <div class="p-3.5">
            @if (secondApp.apiNameNormalized) {
              <img
                  [alt]="secondApp.apiName"
                  class="{{ status() === 'active' ? '' : 'grayscale opacity-60' }}"
                  src="assets/images/apps/{{ secondApp.apiNameNormalized }}.svg"
                  height="30"
                  width="30"
              />
            }
          </div>
        </div>
      </div>
      <div class="sm:flex-grow">
        <p
            class="text-lg font-mark-heavy font-extrabold text-gray-800 mb-1 sm:mb-0.5 -mt-1"
        >
          {{ 'APPINTEGRATIONS_LIST_ITEM_TITLE' | translate: { from: appLabel(firstApp), to: appLabel(secondApp) } }}
        </p>
        @if (!integration.status) {
          <p class="text-xs leading-snug">
            {{ integration.description }}
          </p>
        }
        @if (integration.status === 'error') {
          <div
              class="text-xs leading-snug text-red-500 font-mark-heavy font-extrabold"
          >
            De verbinding met Exact Online is mislukt.
            <a class="underline" href="#">Maak opnieuw verbinding</a>
            om de koppeling te herstellen.
          </div>
        }
        @if (integration.status && integration.status !== 'error') {
          <IntegrationStatus
              [integration]="integration"
              containerClass="flex flex-col-reverse"
              leadingClass="leading-snug"
          ></IntegrationStatus>
        }
      </div>
      <div
          class="
          flex-none
          sm:self-center
          flex
          flex-col
          gap-5
          sm:items-end
          sm:flex-col-reverse
          xl:flex-row
          xl:items-center
        "
      >
        @if (integration.status && integration.status !== 'error') {
          <div
              class="flex items-center gap-5"
          >
            <Toggle
                [active]="integration.userCombiPackage.active"
                (toggled)="onToggleActiveClicked()"
            ></Toggle>

            <div class="flex items-center gap-3.5 text-gray-400">
              <ActionIcon type="run" tooltip="PAGE_DASHBOARD_LABEL_RUN"></ActionIcon>
              <ActionIcon type="list" tooltip="PAGE_DASHBOARD_LABEL_HISTORY"></ActionIcon>
              <ActionIcon type="stats" tooltip="PAGE_DASHBOARD_LABEL_STATISTICS"></ActionIcon>
              <ActionIcon type="edit" tooltip="PAGE_DASHBOARD_LABEL_EDIT"></ActionIcon>
              <ActionIcon type="trash" tooltip="PAGE_DASHBOARD_LABEL_DELETE"></ActionIcon>
            </div>
          </div>
        }

        @if (!integration.status) {
          <Button color="red" size="small">
            Probeer gratis
          </Button>
        }

        @if (integration.status === 'trial-running' ||
        integration.status === 'trial-ended') {
          <Button
              [color]="integration.status === 'trial-ended' ? 'red' : 'blue'"
              size="small"
              (click)="onOrderButtonClicked()"
          >
            Bestel nu
          </Button>
        }
      </div>
    </div>
  `
})
export class IntegrationListItem {
  @Input() firstApp: AppIntegrationFromTo;
  @Input() secondApp: AppIntegrationFromTo;
  readonly description = input('');
  @Input() integration: AppIntegration;
  readonly status = input('');
  orderButtonClicked = output<void>();
  toggleActiveClicked = output<void>();

  onOrderButtonClicked(): void {
    this.orderButtonClicked.emit();
  }

  onToggleActiveClicked(): void {
    this.toggleActiveClicked.emit();
  }

  appLabel(app: AppIntegrationFromTo): string {
    return app?.variant ? `${app.apiName} ${app.variant}` : app?.apiName;
  }
}
